import React from 'react';
import { Shield, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const PrivacyPolicy: React.FC = () => {
  const sections = [
    {
      title: '1. Data Collection',
      content: [
        'Phonetic Pro Text Converter does not collect, store, or share any personal or non-personal information from users.'
      ]
    },
    {
      title: '2. App Usage Statistics',
      content: [
        'We utilize Google Analytics GA4 to collect anonymous usage statistics including:',
        'App session length',
        'Feature usage frequency',
        'Crash reports',
        'General app performance metrics',
        'This data is collected in an aggregated, anonymized format and cannot be used to identify individual users.'
      ]
    },
    {
      title: '3. Data Usage',
      content: [
        'The usage data collected via Google Analytics GA4 is solely used for:',
        'Enhancing app functionality',
        'Identifying areas for improvement',
        'Troubleshooting technical issues'
      ]
    },
    {
      title: '4. Third-Party Services',
      content: [
        'Our app uses Google Analytics GA4, which complies with industry standards for data privacy and security.',
        'For more information on how Google Analytics handles data, please refer to Google\'s Privacy Policy at policies.google.com/privacy'
      ]
    },
    {
      title: '5. Your Privacy Rights',
      content: [
        'You can opt out of analytics tracking by adjusting your device settings or following instructions provided by Google Analytics.'
      ]
    },
    {
      title: '6. Updates to This Policy',
      content: [
        'We may update this Privacy Policy from time to time. Any changes will be effective immediately upon posting the revised policy within the app or on this page.'
      ]
    },
    {
      title: '7. Contact Us',
      content: [
        'If you have any questions or concerns about this Privacy Policy, feel free to contact us at: contact@cemates.me'
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <div className="pt-32 pb-20">
        <div className="max-w-2xl mx-auto px-6">
          {/* Back link */}
          <Link
            to="/portfolio/phonetic"
            className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Phonetic Pro
          </Link>

          {/* Header */}
          <div className="mb-16">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-muted mb-6">
              <Shield className="w-5 h-5 text-foreground" />
            </div>
            <h1 className="text-3xl font-semibold text-foreground mb-3">
              Privacy Policy
            </h1>
            <p className="text-muted-foreground text-sm">
              Phonetic Pro Text Converter • Effective Date: March 25, 2025
            </p>
          </div>

          {/* Intro */}
          <div className="mb-12">
            <p className="text-muted-foreground leading-relaxed">
              We want to assure you that your privacy is our priority. This policy explains how Phonetic Pro Text Converter 
              handles your data and what measures we take to protect your privacy.
            </p>
          </div>

          {/* Sections */}
          <div className="space-y-12">
            {sections.map((section, index) => (
              <div key={index}>
                <h2 className="text-lg font-medium text-foreground mb-4">
                  {section.title}
                </h2>
                <ul className="space-y-3">
                  {section.content.map((item, itemIndex) => (
                    <li key={itemIndex} className="text-muted-foreground text-sm leading-relaxed flex gap-3">
                      <span className="text-muted-foreground/50 select-none">•</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
